import { render, staticRenderFns } from "./PublicQuotationPages14.vue?vue&type=template&id=331f2963&scoped=true&"
import script from "./PublicQuotationPages14.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331f2963",
  null
  
)

export default component.exports